const STORAGE_NAME = 'store';
const FILE_STORAGE_NAME = 'store';
const LOGS_NAME = 'logs';
const DB_NAME = 'bat-redux';
const SAVE_TIME_DELAY = 5000;

export { STORAGE_NAME, FILE_STORAGE_NAME, LOGS_NAME, DB_NAME, SAVE_TIME_DELAY };
